// src/forms/companyProfileConfig.js

const EmployeeConfig = [{ // New field for Salutation
  /*name: 'salutation',
  label: 'Salutation',
  type: 'select',
  defaultValue: '',
  options: [
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Dr', label: 'Dr' },
    { value: 'Prof', label: 'Prof' },
  ],
    rules: { required: 'Salutation is required' },
  },
  // New field for First Name
  {
    name: 'first_name',
    label: 'First Name',
    type: 'text',
    placeholder: 'Enter first name',
    rules: { required: 'First name is required' },
  },
  // New field for Last Name
  {
    name: 'last_name',
    label: 'Last Name',
    type: 'text',
    placeholder: 'Enter last name',
    rules: { required: 'Last name is required' },
  }, */
          
          name: 'gender',
          label: 'Gender',
          type: 'select',
          defaultValue: 'male',
          options: [
            { value: '', label: 'Select Gender' },
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' },
          ],
          rules: { required: 'Gender is required' },
        },
        {
          name: 'date_of_birth',
          label: 'Date of Birth',
          type: 'date',
          placeholder: 'Enter date of birth',
          rules: { required: 'Date of birth is required' },
        },
        {
          name: 'phone_number', // Changed from 'phone_numbers' to 'phone_number'
          label: 'Telephone',
          type: 'text',
          defaultValue: '',
          placeholder: 'Telephone number',
          rules: {required: 'Telephone number is required'},
        },
      
        {
          name: 'email',
          label: 'Email',
          type: 'text',
          defaultValue: '',
          placeholder: 'Enter email address',
          rules: { required: 'Email address is required' },
        },
          {
            name: 'job_title',
            label: 'Job Title',
            type: 'text',
            defaultValue: '',
            placeholder: 'Enter job title',
            rules: { required: 'Job title is required' },
          },
          {
            name: 'department_id',
            label: 'Department',
            type: 'select',
            defaultValue: '',
            
            rules: { required: 'Department is required' },
          },
          {
            name: 'hire_date',
            label: 'Hired Date',
            type: 'date',
            defaultValue: '',
            placeholder: 'Enter hire date',
            rules: { required: 'Hire date is required' },
          },
      
];
export default EmployeeConfig;
  